import configRequest from './request';
import { IConfig } from '../../types/interfaces/config';
import { Observable } from 'rxjs';

const configObservable = new Observable<IConfig[]>((subscriber) => {
  configRequest()
    .then((data) => {
      subscriber.next(data);
      subscriber.complete();
    })
    .catch((data) => {
      subscriber.next(data);
      subscriber.complete();
    });
});

export default configObservable;
